import './App.css';
import {Book} from "./components/Book";
import {Navbar} from "./components/Navbar";
import {ChakraProvider} from "@chakra-ui/react";

function App() {

    return (
        <ChakraProvider>
            <Navbar />
            <Book />
        </ChakraProvider>
    );
}

export default App;
